import { render, staticRenderFns } from "./instagram-speed.vue?vue&type=template&id=388d31ce&scoped=true&"
import script from "./instagram-speed.vue?vue&type=script&lang=js&"
export * from "./instagram-speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d31ce",
  null
  
)

export default component.exports